import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.prototype.$http = axios.create({
  // baseURL: "http://10.10.170.45/api",
  // baseURL: "http://localhost/ppid-big/public/api",
  baseURL: "https://ppid.big.go.id/api",
});
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    currentAdmin: null,
    countOfInformationCategory: [],
  },
  mutations: {
    getCurrentUser(state, user) {
      state.currentUser = user;
    },
    getCurrentAdmin(state, user) {
      state.currentAdmin = user;
    },
    countOfInformationCategory(state, data) {
      state.countOfInformationCategory = data
      let sum = 0;
      state.countOfInformationCategory.forEach((item, idx) => {
        sum+=parseInt(item.count)
      })
      state.countOfInformationCategory.unshift({ id: "0", count: sum });
    }
  },
  actions: {
    async getCurrentUser(context) {
      if (!localStorage.getItem("token-ppidbig")) {
        context.commit("getCurrentUser", null);
        return null;
      }
      await Vue.prototype.$http
        .get("/user/info/", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token-ppidbig"),
          },
        })
        .then( (result) => {
          context.commit("getCurrentUser", result.data);
        })
        .catch(error => {})
    },
    async getCurrentAdmin(context) {
      if (!localStorage.getItem("token-admin")) {
        context.commit("getCurrentAdmin", null);
        return null;
      }
      let token = await localStorage.getItem("token-admin")
      await Vue.prototype.$http
        .get("/admin/info/", {
          headers: {
            Authorization: "Bearer " + token
          },
        })
        .then((result) => {
          
          context.commit("getCurrentAdmin", result.data);
        })
        .catch(error => {})
    },
    getCountOfInformationCategory(context) {
      Vue.prototype.$http
        .get("/information/category/count/%25", {
         
        })
        .then(async (result) => {
          context.commit("countOfInformationCategory", result.data);
        });
    }
  },
  modules: {},
});
